// extracted by css-extract-rspack-plugin
export default {"banner":"banner-iMaO2t","bannerAvatar":"bannerAvatar-EjyUcM","bannerText":"bannerText-VMvE6s","bannerHint":"bannerHint-D9BU21"};